<template>
  <div class="footer">
    <div class="cookie-div" :class="{'cookie-hide': cookieShow}">
      <div class="cookie-center cookie-pc">
        <div class="cookie-left">
          <div class="cookie-top">{{$t('collectionPrefrences')}}</div>
          <div class="cookie-bottom">
            {{$t('byClickAcceptAllowRoompaiMedia')}}
          </div>
        </div>
        <div class="cookie-right">
          <div class="cookie-top">
            <el-button type="primary" class="dialog-accept" @click="cookieAccept"> {{$t('accept')}} </el-button>
          </div>
          <div class="cookie-bottom">
            <el-button type="primary" class="dialog-refuse" @click="cookieRefuse"> {{$t('decline')}} </el-button>
          </div>
        </div>
      </div>
      <!-- 之前注释掉了  不知道因为什么 需要问小宇 -->
      <div class="cookie-center cookie-mobile">
        <div class="cookie-mobile-top">
          <div class="cookie-top">{{$t('collectionPrefrences')}}</div>
          <div class="cookie-bottom">
            {{$t('byClickAcceptAllowRoompaiMedia')}}
          </div>
        </div>
        <div class="cookie-mobile-bottom">
          <div class="cookie-left">
            <el-button type="primary" class="dialog-refuse" @click="cookieRefuse"> {{$t('decline')}} </el-button>
          </div>
          <div class="cookie-right">
            <el-button type="primary" class="dialog-accept" @click="cookieAccept"> {{$t('accept')}} </el-button>
          </div>
        </div>
      </div>
    </div>
    <!--
    <el-container class="contact-mode">
      <div class="contact-half contact-email">
        <p><span>{{$t('customerServiceEmail')}}：</span></p>
        <p>cs_client@51smart.com</p>
      </div>
      <div class="contact-half contact-phone">
        <p><span>{{$t('customerServicePhone')}}：</span></p>
        <p>0411-84949537        （{{$t('internationalCall')}}）</p>
        <p>0086-411-84949537    （{{$t('domesticCall')}}）</p>
      </div>
    </el-container>
    -->
    <el-container class="el-footer">
      <div class="footer-center footer-main" :class="{'footer-main-visible': showBottomText, 'footer-main-hidden': !showBottomText }">
        <div class="footer-top" :style="{borderBottom: bottomLine}">
            <span><router-link :to="{name:'frequently', params: {'querys': common.linkEncode({'source': source, 'conver': conver}, 'obj')}}" class="footer-link"> <span @click="footerClick('frequently')">{{$t('faq')}}</span> </router-link></span>
            <el-divider direction="vertical"></el-divider>
            <span><router-link :to="{name:'policy', params: {'querys': common.linkEncode({'source': source, 'conver': conver}, 'obj')}}" class="footer-link"> <span @click="footerClick('policy')">{{$t('privacyPolicy')}}</span> </router-link></span>
            <el-divider direction="vertical"></el-divider>
            <span><router-link :to="{name:'clause', params: {'querys': common.linkEncode({'source': source, 'conver': conver}, 'obj')}}" class="footer-link"> <span @click="footerClick('clause')">{{$t('termsOfUse')}}</span> </router-link></span>
            <el-divider direction="vertical"></el-divider>
            <span v-if="aboutUsShow"><router-link :to="{name:'aboutUs', params: {'querys': common.linkEncode({'source': source, 'conver': conver}, 'obj')}}" class="footer-link"> <span @click="footerClick('aboutUs')">{{$t('aboutUs')}}</span> </router-link></span>
            <el-divider direction="vertical" v-if="aboutUsShow"></el-divider>
            <span><router-link :to="{name:'refundPolicy', params: {'querys': common.linkEncode({'source': source, 'conver': conver}, 'obj')}}" class="footer-link"> <span @click="footerClick('refundPolicy')">{{$t('refundPolicy')}}</span> </router-link></span>
            <el-divider direction="vertical"></el-divider>
            <span><router-link :to="{name:'contactUs', params: {'querys': common.linkEncode({'source': source, 'conver': conver}, 'obj')}}" class="footer-link"> <span @click="footerClick('contactUs')">{{$t('contactUs')}}</span> </router-link></span>
        </div>
        <div class="footer-lower">
          <span v-if="aboutUsShow">© 2023 Letsfly Limited. All Rights Reserved.</span>
          <!-- <span style="display:inherit;" v-if="source === 'roompai' && language === 'en'">All material herein © 2023 Yisike Information Technology Co. Ltd. All Rights Reserved.</span> -->
          <!-- <span style="display:inherit;" v-if="site === 'www' && source === 'roompai' && language === 'en'">All material herein © 2023 北京驿思客信息技术有限公司 All Rights Reserved.</span> -->
          <!-- <span style="display:inherit;" v-if="site === 'www' && source === 'roompai' && language === 'zh'">版权所有 © 2023 北京驿思客信息技术有限公司 保留所有权利</span> -->
        </div>
      </div>
      <div class="footer-bottom"></div>
    </el-container>
    <!-- <el-backtop v-if="common.isMobile() === false && source !== 'sec'"></el-backtop> -->
    <div class="mainMask" v-if="frameCodeDialog" @click="frameCodeDialog = !frameCodeDialog"></div>
    <div class="qrcode-pc" :style="codeStyle" v-if="frameCodeDialog === true && source === 'sec'">
      <div>{{ $t('qrCodePresale') }}</div>
      <div style="width:100px; height:100px;">
        <img style="width: 100%; height: 100%; object-fit: contain;" :src="qrCodePresale.newimg" >
      </div>
      <div>{{ $t('qrCodePostsale') }}</div>
      <div style="width:100px; height:100px;">
        <img style="width: 100%; height: 100%; object-fit: contain;" :src="qrCodePostsale.newimg" >
      </div>
    </div>
    <div class="sec-top" :class="{'sec-top-mobile': common.isMobile() === true}" v-show="showTop">
      <div class="service"><img src="/static/img/service.png" style="width:20px; height:20px; margin:10px;"></div>
      <div class="code" v-show="qrcodeShow"><img src="/static/img/code.png" style="width:30px; height:30px; margin:5px;" @click="frameCodeDialog = true"></div>
      <div class="tool-link" v-if="oaLinkShow" @click="skipOaLink">
        <img src="/static/img/inspect.png" style="width: 25px;height: 25px;margin: 5px 5px; display:none">
      </div>
      <div class="top" @click="gotoTop"><img src="/static/img/top.png" style="width:12px; height:12px; margin:5px;"></div>
    </div>
  </div>
</template>

<script>
import { getUserInfo, setUserCookie } from '@/request/user.js'
import { getCode } from '@/request/question.js'
import { eventBus } from '@/util/languageHeader.js'
export default {
  name: 'publicFooter',
  data () {
    return {
      cookieShow: false,
      source: 'roompai',
      qrCodePresale: '',
      qrCodePostsale: '',
      frameCodeDialog: false,
      showTop: true,
      oaLinkShow: false,
      codeStyle: '',
      language: this.common.languageSet(this),
      qrcodeShow: false,
      aboutUsShow: false,
      bottomLine: 'unset',
      site: 'us',
      showBottomText: false,
      conver: ''
    }
  },
  created: function () {
    let nowsource = this.common.linkQuerys.source
    if (location.host === 'www.roompai.com' && nowsource !== 'google' && nowsource !== 'google2') {
      this.aboutUsShow = true
      this.bottomLine = '1px solid #606266'
    }
    let conver = this.common.linkQuerys.conver
    if (conver === 1 || conver === '1') {
      this.conver = conver
    }
    if (location.host === 'www.roompai.com') {
      this.site = 'www'
    } else {
      this.site = 'us'
    }

    this.selectCookie()
    eventBus.$on('language', (data) => {
      this.getQrCode(data)
    })
  },
  mounted () {
    var source = this.common.linkQuerys.source
    if (source !== '' && source !== undefined && source !== null) {
      this.source = source
    }
    if (this.source === 'sec' && this.language === 'zh' && (this.qrCodePresale !== '' || this.qrCodePostsale !== '')) {
      this.qrcodeShow = true
    } else {
      this.qrcodeShow = false
    }
    // 悬浮框 PC端全部展示，手机端只有 首页 和 酒店列表页 展示
    var path = this.common.routePath(this.$route.path)
    if (this.common.isMobile() === true && (path !== '/' && path.indexOf('HotelList') === -1)) {
      this.showTop = false
    }
    if (this.common.isMobile() === true) {
      var topRight = document.documentElement.clientWidth * 0.05 + 40
      this.codeStyle = 'right: ' + topRight + 'px; bottom: 10px;'
    }
    // if (common.isMobile() === true)
    if (this.source === 'sec' && this.language === 'zh') {
      this.getCode()
    }

    // 底部链接跳转
    this.oaLinkShow = localStorage.getItem('oaLinkShow')

    // 底部加载
    this.scrollFooterTextShow()
  },
  methods: {
    getQrCode: function (news) {
      this.language = news
      if (this.source === 'sec' && news === 'zh') {
        this.getCode()
      } else {
        this.qrcodeShow = false
      }
    },
    toggleSlide: function (dom, bottom, time) {
      dom.style.transition = 'bottom ' + time + 's'
      if (bottom === 'inherit') {
        dom.style.bottom = '-500px'
      } else {
        dom.style.bottom = '-4px'
      }
    },
    selectCookie: function () {
      var getCookie = localStorage.getItem('getCookie')
      if (getCookie === null) {
        this.getUserCookie()
      } else {
        this.setUserCookie(1)
      }
    },
    getUserCookie: function () {
      var that = this
      var time = parseInt(new Date().getTime() / 1000)
      var token = localStorage.getItem('token')
      var dataJson = {
        'time': time,
        'token': token
      }
      var data = this.common.encryptionData(dataJson, this)
      getUserInfo(data).then(res => {
        if (res.data.is_cookie === 1) {
          this.cookieShow = true
          localStorage.setItem('getCookie', 1)
        } else if (res.data.is_cookie === 2) {
          this.cookieShow = true
          localStorage.setItem('getCookie', 2)
        } else {
          that.toggleSlide(document.querySelector('.cookie-div'), '0px', 4)
        }
      })
    },
    cookieAccept: function () {
      this.cookieShow = true
      this.toggleSlide(document.querySelector('.cookie-div'), 'inherit', 4)
      localStorage.setItem('getCookie', '1')
      this.setUserCookie(2)
    },
    cookieRefuse: function () {
      this.cookieShow = true
      this.toggleSlide(document.querySelector('.cookie-div'), 'inherit', 4)
      localStorage.setItem('getCookie', '2')
      this.setUserCookie(2)
    },
    setUserCookie: function (type) {
      var that = this
      var source = 40
      var time = parseInt(new Date().getTime() / 1000)
      var token = localStorage.getItem('token')
      var getCookie = localStorage.getItem('getCookie')
      var sessionid = this.common.sessionidGet(this)
      var dataJson = {
        'time': time,
        'token': token,
        'getCookie': getCookie,
        'source': source,
        'sessionid': sessionid,
        'operation': 'setUserCookie'
      }
      var data = this.common.encryptionData(dataJson, this)
      setUserCookie(data).then(res => {
        if (type === 2 && res.flag === 200) {
          this.cookieShow = true
          that.toggleSlide(document.querySelector('.cookie-div'), 'inherit', 4)
        }
      })
    },
    getCode () {
      var time = parseInt(new Date().getTime() / 1000)
      var sessionid = this.common.sessionidGet(this)
      var dataJson = {
        'time': time,
        'sessionid': sessionid
      }
      var data = this.common.encryptionData(dataJson, this)
      getCode(data).then(res => {
        if (res.flag === '200') {
          this.qrCodePresale = res.data[0]
          this.qrCodePostsale = res.data[1]
          if (this.source === 'sec' && this.language === 'zh' && (this.qrCodePresale !== '' || this.qrCodePostsale !== '')) {
            this.qrcodeShow = true
          } else {
            this.qrcodeShow = false
          }
        }
      })
    },
    gotoTop: function () {
      window.scrollTo({
        top: top,
        behavior: 'smooth'
      })
    },
    footerClick: function (type) {
      // 点击埋点 埋点记录
      this.clickPageAction(type, '', {'type': type})
    },
    skipOaLink: function () {
      var hotelid = this.common.linkQuerys.hotelid
      var checkin = this.common.linkQuerys.start_date
      var checkout = this.common.linkQuerys.end_date
      var room = this.common.linkQuerys.room
      var adult = this.common.linkQuerys.adult
      var child = this.common.linkQuerys.child
      var source = this.source
      var online = 1
      // if (source === 'lulupai') {
      //   online = 0
      // }

      // 规则
      if (hotelid === '' || hotelid === null || hotelid === undefined) {
        alert('目前仅支持在详情页点击')
        return false
      }
      if (checkin === '' || checkin === null || checkin === undefined) {
        alert('无入住日期')
        return false
      }
      if (checkout === '' || checkout === null || checkout === undefined) {
        alert('无离店日期')
        return false
      }
      if (room === '' || room === null || room === undefined) {
        room = 1
      }
      if (adult === '' || adult === null || adult === undefined) {
        alert('无成人数')
        return false
      }
      if (child === '' || child === null || child === undefined) {
        alert('无儿童数')
        return false
      }
      // 埋点
      var data = {
        'type': 'skipOaLink',
        'hotelid': hotelid,
        'checkin': checkin,
        'checkout': checkout,
        'room': room,
        'adult': adult,
        'child': child,
        'source': source
      }
      // 点击埋点 埋点记录
      this.clickPageAction('skipOaLink', '', data)

      var lfhotelid = this.common.hotelid_decrypt(hotelid)
      window.open('https://admin.hotel.51smart.com/admin/price/?mod=hotelSearchNew&do=list&searchType=1&act=search&type=&enablecache=0&agentname=None&platform=' + source + '&hotelname=&lfhotelid=' + lfhotelid + '&checkin=' + checkin + '&checkout=' + checkout + '&roomcount=' + room + '&adults=' + adult + '&children=' + child + '&childrenAge=0&order_id=&tpl=2&online=' + online + '&roompaiDetail=1')
    },
    scrollFooterTextShow: function () {
      var that = this
      window.addEventListener('scroll', function () {
        var scrollHeight = Math.max(
          document.body.scrollHeight,
          document.documentElement.scrollHeight,
          document.body.offsetHeight,
          document.documentElement.offsetHeight,
          document.body.clientHeight,
          document.documentElement.clientHeight
        )
        var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop

        if (scrollTop + window.innerHeight >= scrollHeight - 300) {
          that.showBottomText = true
        } else {
          that.showBottomText = false
        }
      })
    }
  }
}
</script>

<style scoped>
.footer-top .footer-link{color: #606266;text-decoration: none;}
.footer-top .el-divider--vertical{background: #606266;}
.footer .cookie-div{width: 100%;height: 25%;background: #71543D;background-color: rgba(79, 76, 76, 0.8);position: fixed;bottom: -500px;z-index: 201;padding: 1.1% 0px;color: white;font-size: 14px;}
.cookie-hide{display:none;}
.cookie-div .cookie-pc{margin: 0 auto;width: 1100px;height: 100%;font-family: PingFangSCRegular, 'PingFang SC', sans-serif;
    font-weight: 400;}
.cookie-div .cookie-pc .cookie-left{width: 70%; height: 100%; float: left;}
.cookie-div .cookie-pc .cookie-left .cookie-top{width: 100%;height: 40%;/*line-height: 50px;*/line-height:3.5;}
.cookie-div .cookie-pc .cookie-left .cookie-bottom{width: 100%; height: 60%;}
.cookie-div .cookie-pc .cookie-right{width: 30%; height: 100%; float: right;text-align: right;}
.cookie-div .cookie-pc .cookie-right .cookie-top{width: 100%;height: 50%;/*line-height: 80px;*/line-height: 5.7;}
.cookie-div .cookie-pc .cookie-right .cookie-bottom{width: 100%; height: 50%;/*line-height: 50px;*/line-height: 3.5;}
.cookie-div .cookie-pc .cookie-right .dialog-accept{width: 130px;background-color: rgb(252, 210, 5, 1); color:#4F4C4C;border-color: rgb(252, 210, 5, 1);}
.cookie-div .cookie-pc .cookie-right .dialog-accept:hover{background-color: #333;border: 1px solid #333;border-radius: 4px;font-weight: 500;font-size: 14px;color: #FFFFFF;}
.cookie-div .cookie-pc .cookie-right .dialog-refuse{width: 130px;background-color: #333;border: 1px solid #333;border-radius: 4px;font-weight: 500;font-size: 14px;color: #FFFFFF;}
.cookie-div .cookie-pc .cookie-right .dialog-refuse:hover{background-color: rgb(252, 210, 5, 1); color:#4F4C4C;border-color: rgb(252, 210, 5, 1); }

.cookie-div .cookie-mobile{margin: 0 auto;width: 90%;height: 100%;font-family: PingFangSCRegular, 'PingFang SC', sans-serif;
    font-weight: 400;}
.cookie-div .cookie-mobile .cookie-mobile-top{margin:10px 0px;width: 100%; height: 60%;}
.cookie-div .cookie-mobile .cookie-mobile-top .cookie-top{margin-bottom: 20px;}
.cookie-div .cookie-mobile .cookie-mobile-bottom{margin:10px 0px;width: 100%; height: 40%;}

.cookie-div .cookie-mobile .cookie-mobile-bottom .cookie-left{width: 50%;height: 100%;float: left;text-align: center;margin: 15px 0px;}
.cookie-div .cookie-mobile .cookie-mobile-bottom .cookie-right{width: 50%; height: 100%;float: right;text-align: center;margin: 15px 0px;}
.cookie-div .cookie-mobile .cookie-mobile-bottom .dialog-accept{width: 98%;float:right;height: 35px;background-color: rgb(252, 210, 5, 1); color:#4F4C4C;border-color: rgb(252, 210, 5, 1);}
.cookie-div .cookie-mobile .cookie-mobile-bottom .dialog-accept:hover{background-color: #333;border: 1px solid #333;border-radius: 4px;font-weight: 500;font-size: 14px;color: #FFFFFF;}
.cookie-div .cookie-mobile .cookie-mobile-bottom .dialog-refuse{width: 98%;height: 35px;background-color: #333;border: 1px solid #333;border-radius: 4px;font-weight: 500;font-size: 14px;color: #FFFFFF;}
.cookie-div .cookie-mobile .cookie-mobile-bottom .dialog-refuse:hover{background-color: rgb(252, 210, 5, 1); color:#4F4C4C;border-color: rgb(252, 210, 5, 1); }
.cookie-div .cookie-mobile .cookie-mobile-bottom /deep/ .el-button{padding: 10px 20px;}
.mainMask{position: fixed; top: 0px;left: 0px;width: 100%;height: 100%;background: rgb(0,0,0,0.4);z-index: 2000;}

.qrcode-pc{width:100px !important; height: 232px !important;position: fixed; right: 80px;bottom: 40px;z-index: 2001; background-color: #fff; font-size: 12px; padding: 10px 5px; text-align: center;}
.sec-top{height: auto; width: 40px; background: inherit; box-shadow: none; text-align: center; line-height: 40px; background-color: #fff; position: fixed; right: 40px; bottom: 40px; border: none; border-radius: 20px 20px 20px 20px; opacity: 0.9;box-shadow: 0 0 6px rgb(0 0 0 / 12%);z-index: 201;}
.sec-top-mobile{right: 5%; bottom: 10px;}

.sec-top div{width:40px;height:40px; cursor: pointer;}
.sec-top .service:hover{ border: none;border-radius: 20px 20px 0 0;background: inherit;  background-color: #5392F9; border: none;-moz-box-shadow: none; -webkit-box-shadow: none;box-shadow: none;}
.sec-top .tool-link{background-image: url(/static/img/inspect.png);background-size: 25px 25px;background-repeat: no-repeat;background-position: center;}
.sec-top .tool-link:hover{border: none;background: inherit;  background-color: #5392F9; border: none;-moz-box-shadow: none; -webkit-box-shadow: none;box-shadow: none;background-image: url(/static/img/inspect-hover.png);background-size: 25px 25px;background-repeat: no-repeat;background-position: center;}
.sec-top .code:hover{border: none;background: inherit;  background-color: #5392F9; border: none;-moz-box-shadow: none; -webkit-box-shadow: none;box-shadow: none;}
.sec-top .top:hover{border: none;background: inherit; border-radius: 0 0 20px 20px; background-color: #5392F9; border: none;-moz-box-shadow: none; -webkit-box-shadow: none;box-shadow: none;}

/* 底部上滑动画 */
.footer-main-hidden {opacity: 0; transform: translateY(0%);}
@keyframes fade-in-up {
  from {
    opacity: 0;
    transform: translateY(10%);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.footer-main-visible {
  animation: fade-in-up 0.5s ease-in-out forwards;
}

@media only screen and (min-width:1610px) {
  .cookie-div .cookie-pc .cookie-left .cookie-top{line-height: 5.5;}
  .cookie-div .cookie-pc .cookie-right .cookie-top{line-height: 9.7;}
}
</style>



// WEBPACK FOOTER //
// src/components/public/publicFooter.vue